import styled from 'styled-components';

export const EWarrantyDealerContainerStyled = styled.div`

`;
